export const mountTitle = (array: any[], active: string) => {
  if(array && array.length > 1) {
    const modulo = array.find((it) => it.slug === active);

    if(!modulo) {
      return ""
    }

    return modulo?.title;
  }
}

export const mountArray = (array: any[], pathname: string) => {
  if(array && array.length > 0) {
    const modulesArray: { label: string, link: string }[] = [];
      
    const url = pathname.substring(0, pathname.lastIndexOf('/'));
    array.map((it) => modulesArray.push({ label: it.title, link: `${url}/${it.slug}` }));

    return modulesArray;
  }
}

export const mountArrayDisciplines = (array: any[], pathname: string, type: string) => {
  if(array && array.length > 0) {
    const modulesArray: { label: string, link: string }[] = [];
    array.map((it) => modulesArray.push({ label: it.title, link: `${pathname}/${it.slug}${type}` }));

    return modulesArray;
  }
}